import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, useLocation, useNavigationType } from "react-router-dom";
import { useEffect } from "react";
import { AnimatePresence } from "framer-motion";
import PageTransition from "@/components/PageTransition";
import Index from "./pages/Index";
import WerWirSind from "./pages/WerWirSind";
import Portfolio from "./pages/Portfolio";
import LeadershipRefugium from "./pages/LeadershipRefugium";
import RefugiumGalerie from "./pages/RefugiumGalerie";
import Beratung from "./pages/Beratung";
import BeratungOrganisationsentwicklung from "./pages/BeratungOrganisationsentwicklung";
import BeratungStrategieberatung from "./pages/BeratungStrategieberatung";
import BeratungProzessberatung from "./pages/BeratungProzessberatung";
import Qualifizierung from "./pages/Qualifizierung";
import Coaching from "./pages/Coaching";
import Supervision from "./pages/Supervision";
import UnsereHaltung from "./pages/UnsereHaltung";
import Partner from "./pages/Partner";
import Partnernetzwerk from "./pages/Partnernetzwerk";
import Blog from "./pages/Blog";
import BlogArtikel from "./pages/BlogArtikel";
import Kontakt from "./pages/Kontakt";
import Impressum from "./pages/Impressum";
import AGBs from "./pages/AGBs";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    if (navType !== "POP") {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }
  }, [pathname, navType]);

  return null;
};

const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<PageTransition><Index /></PageTransition>} />
        <Route path="/wer-wir-sind" element={<PageTransition><WerWirSind /></PageTransition>} />
        <Route path="/wer-wir-sind/:memberId" element={<PageTransition><WerWirSind /></PageTransition>} />
        <Route path="/leadership-refugium" element={<PageTransition><LeadershipRefugium /></PageTransition>} />
        <Route path="/refugium-galerie" element={<PageTransition><RefugiumGalerie /></PageTransition>} />
        <Route path="/portfolio" element={<PageTransition><Portfolio /></PageTransition>} />
        <Route path="/portfolio/beratung" element={<PageTransition><Beratung /></PageTransition>} />
        <Route path="/portfolio/beratung/organisationsentwicklung" element={<PageTransition><BeratungOrganisationsentwicklung /></PageTransition>} />
        <Route path="/portfolio/beratung/strategieberatung" element={<PageTransition><BeratungStrategieberatung /></PageTransition>} />
        <Route path="/portfolio/beratung/prozessberatung" element={<PageTransition><BeratungProzessberatung /></PageTransition>} />
        <Route path="/portfolio/qualifizierung" element={<PageTransition><Qualifizierung /></PageTransition>} />
        <Route path="/portfolio/coaching" element={<PageTransition><Coaching /></PageTransition>} />
        <Route path="/portfolio/supervision" element={<PageTransition><Supervision /></PageTransition>} />
        <Route path="/unsere-haltung" element={<PageTransition><UnsereHaltung /></PageTransition>} />
        <Route path="/partnernetzwerk" element={<PageTransition><Partnernetzwerk /></PageTransition>} />
        <Route path="/partner" element={<PageTransition><Partner /></PageTransition>} />
        <Route path="/blog" element={<PageTransition><Blog /></PageTransition>} />
        <Route path="/blog/:slug" element={<PageTransition><BlogArtikel /></PageTransition>} />
        <Route path="/kontakt" element={<PageTransition><Kontakt /></PageTransition>} />
        <Route path="/impressum" element={<PageTransition><Impressum /></PageTransition>} />
        <Route path="/agbs" element={<PageTransition><AGBs /></PageTransition>} />
        <Route path="*" element={<PageTransition><NotFound /></PageTransition>} />
      </Routes>
    </AnimatePresence>
  );
};

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <AnimatedRoutes />
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
